import { ROUTE } from 'routers/data';

export const sendEmail = (
  email: string,
  subject: string = '',
  body: string = '',
) => {
  window.open(`mailto:${email}?subject=${subject}&body=${body}`);
};

export const callPhone = (countryCode: string = '+549', phone: string) => {
  window.open(`tel:${countryCode} ${phone}`);
};

export const toSingleArray = (d: any): any => {
  const aux = [];
  const keys = Object.keys(d.subcategories || {});
  for (let index = 0; index < keys.length; index++) {
    if (d.subcategories[keys[index]].isCategory) {
      aux.push(...toSingleArray(d.subcategories[keys[index]]));
    } else {
      aux.push(d.subcategories[keys[index]]);
    }
  }
  return aux;
};

export const getLatLngFromAddress = async (
  address: string,
): Promise<{ lat: any; lng: any }> => {
  if (!address) return { lat: undefined, lng: undefined };
  const urlEndPoint = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    address,
  )}&key=${process.env.REACT_APP_FIREBASE_API_KEY!}`;
  const resp: any = await (await fetch(urlEndPoint)).json();
  return {
    lat: resp?.results[0]?.geometry?.location?.lat,
    lng: resp?.results[0]?.geometry?.location?.lng,
  };
};

/* Obtener la direccion segun Lat y Lng */
export const getAddresFromLatLng = async (
  lat: string,
  lng: string,
): Promise<{
  city?: string;
  state?: string;
  country?: string;
}> => {
  if (!lat || !lng)
    return { city: undefined, state: undefined, country: undefined };
  let urlEndPoint = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lng}&localityLanguage=es`;
  let resp = await (await fetch(urlEndPoint)).json();
  resp.principalSubdivision = resp.principalSubdivision.replace(
    'Provincia de ',
    '',
  );
  return {
    city: resp?.city,
    state: resp?.principalSubdivision,
    country: resp?.countryName,
  };
};

export const compareStrings = (a: string, b: string) => {
  var normalizedA = a
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  var normalizedB = b
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  return normalizedA === normalizedB;
};

export const getIdByLabel = (
  array: { id: string; label: string }[],
  label?: string,
) => {
  if (!label) return null;
  const city = array?.find((city) => compareStrings(city.label, label));
  return city ? city.id : null;
};

export const getStep = (pathname: string) => {
  if (pathname.match(ROUTE.complateProfileStep1)) return 0;
  if (pathname.match(ROUTE.complateProfileStep2)) return 1;
  if (pathname.match(ROUTE.complateProfileStep3)) return 2;
  if (pathname.match(ROUTE.complateProfileStep4)) return 3;
  return 0;
};
